module.exports = __webpack_public_path__ + "img/map-bg.ee2cbf6e.png";